import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

/* LIST ================= */
export const fetchPolicies = createAsyncThunk(
  "policies/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosPrivate.get(api.policies);
      return res.data.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Fetch failed");
    }
  }
);

/* CREATE ================= */
export const createPolicy = createAsyncThunk(
  "policies/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosPrivate.post(api.policies, payload);
      return res.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Create failed");
    }
  }
);

/* UPDATE ================= */
export const updatePolicy = createAsyncThunk(
  "policies/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await axiosPrivate.put(`${api.policies}/${id}`, payload);
      return res.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Update failed");
    }
  }
);

const policiesSlice = createSlice({
  name: "policies",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPolicies.pending, (s) => {
        s.loading = true;
      })
      .addCase(fetchPolicies.fulfilled, (s, a) => {
        s.loading = false;
        s.list = a.payload || [];
      })
      .addCase(fetchPolicies.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload;
      })

      .addCase(createPolicy.fulfilled, (s, a) => {
        s.list.unshift(a.payload);
      })
      .addCase(updatePolicy.fulfilled, (s, a) => {
        const index = s.list.findIndex(p => p.id === a.payload.id);
        if (index !== -1) {
          s.list[index] = a.payload;
        }
      });
  },
});

export default policiesSlice.reducer;
